let uid = 0

export default {
    name: "SchemaMarkupTextField",

    props: {
        modelValue: { type: String, default: "" },
        label: { type: String, default: "" },
        readonly: { type: Boolean, default: false }
    },

    emits: ["update:modelValue"],

    setup(props, { emit }) {
        const fieldId = `kb-text-${++uid}`
        const onInput = (event) => emit("update:modelValue", event.target.value)
        return { fieldId, onInput }
    }
}
